module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/bg_mv2512-sp-4320dc90fe7a4dfe689aebf9c40a9ba3.jpg";